import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { SUPPORTED_LANGS } from '@/i18n';
import i18n from '@/i18n';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate(`/${getLang()}/auth`);
      return;
    }

    const sessionId = match[1];
    exchangeSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, '', window.location.pathname);
        navigate(`/${getLang()}/calculator`, { state: { user }, replace: true });
      })
      .catch(() => {
        navigate(`/${getLang()}/auth`);
      });
  }, [exchangeSession, navigate]);

  // Process silently - no loading UI
  return null;
}

function getLang() {
  const stored = i18n.language;
  return SUPPORTED_LANGS.includes(stored) ? stored : 'en';
}
